export const resolveEntityTags = (row: object): string[] => {
  const value = (row as { tags?: unknown }).tags;
  if (!Array.isArray(value)) return [];
  return value.filter((tag): tag is string => typeof tag === 'string' && tag.length > 0);
};

export const formatEntityTagsLabel = (tags: string[] | undefined): string => {
  if (!tags || tags.length === 0) return '-';
  return tags.join(', ');
};
